import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class VatNumberForm extends BaseModel {
  vat_number = '';

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    vat_number: 'max:255'
  };

  attributeLabels = {
    vat_number: i18n.t('VAT Number'),
  };
}
